import BaseModel from './base-model';
import PropertyType from './property-type';
/**
  "type": {
      "@id": 400067,
      "CODE": "description",
      "@COMMON_NAME": "description"
  },
  "@id": 407008,
  "sequence": 10,
  "@COMMON_NAME": "Etiqueta campo descripción",
  "required": 0
 */
export default class ElementProperty extends BaseModel {
  constructor(opts = {}) {
    super(opts);
    this.alias = opts.alias;
    this.sequence = opts.sequence;
    this.required = opts.required === 1;
    this.config = opts.config;
    this.dependency = opts.dependency;
    this.params = opts.params;
    this.special_values = opts.special_values;

    this.type = null;
    if (opts.type !== null) {
      this.type = new PropertyType(opts.type);

      // group fields must be mapped as custom element properties
      if (this.type.name === 'group' && this.params.fields != null && this.params.fields.length) {
        this.params.fields = this.params.fields.map((field) => new ElementProperty(field));
      }
    }
  }
}
